var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrademate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9999 24.8571L18.4602 21.88C19.1979 20.3763 21.3658 20.4498 21.9999 21.9999C22.6341 23.5501 24.802 23.6235 25.5396 22.1198L26.9999 19.1428M31.5262 21.9999C31.5262 24.5472 31.5262 25.8209 30.975 26.8954C30.8995 27.0425 30.8167 27.1859 30.727 27.3248C30.0721 28.3395 28.9691 28.9763 26.7631 30.2499C24.557 31.5236 23.454 32.1604 22.2479 32.2203C22.0827 32.2285 21.9172 32.2285 21.752 32.2203C20.5458 32.1604 19.4428 31.5236 17.2368 30.2499C15.0308 28.9763 13.9278 28.3395 13.2728 27.3248C13.1831 27.1859 13.1004 27.0425 13.0249 26.8954C12.4736 25.8209 12.4736 24.5472 12.4736 21.9999C12.4736 19.4527 12.4736 18.179 13.0249 17.1045C13.1004 16.9573 13.1831 16.814 13.2728 16.675C13.9278 15.6604 15.0308 15.0236 17.2368 13.7499C19.4428 12.4763 20.5458 11.8395 21.752 11.7796C21.9172 11.7714 22.0827 11.7714 22.2478 11.7796C23.454 11.8395 24.557 12.4763 26.7631 13.7499C28.9691 15.0236 30.0721 15.6604 30.727 16.675C30.8167 16.814 30.8995 16.9573 30.975 17.1045C31.5262 18.179 31.5262 19.4527 31.5262 21.9999Z",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrademate);
export default __webpack_public_path__ + "static/media/trademate.046c86fe15e7d018dba93cd83a132593.svg";
export { ForwardRef as ReactComponent };